module.exports = __webpack_public_path__ + "img/2.caccdd11.jpg";